import { $, extend, hasParentsClass } from './helper'
import 'js-cookie'

export class ContrastButton {
  constructor (settings, selectors, classes) {
    this.settings = extend({
    }, settings)

    this.selectors = extend({
    }, selectors)

    this.classes = extend({
      button: 'btn--contrast-mode',
      contrastMode: 'is--contrast-mode'
    }, classes)

    this.$body = $('body')
    this.$Cookies = require('js-cookie')
  }

  init () {
    this.addEvents()

    if (this.getCookie('contrastmode') === '1') {
      this.$body.classList.add(this.classes.contrastMode)
    }
  }

  addEvents () {
    this.$body.addEventListener('click', (event) => {
      if (hasParentsClass(event.target, this.classes.button)) {
        if (this.$body.classList.contains(this.classes.contrastMode)) {
          this.setCookie('contrastmode', '0')
          this.$body.classList.remove(this.classes.contrastMode)
        } else {
          this.setCookie('contrastmode', '1')
          this.$body.classList.add(this.classes.contrastMode)
        }
      }
    })
  }

  setCookie (name = '', value = '0') {
    this.$Cookies.set(name, value, {
      path: '/'
    })
  }

  getCookie (name) {
    return this.$Cookies.get(name)
  }
}

export default ContrastButton
